// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#coming-soon-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  font-family: "Sora", sans-serif !important;
}
#coming-soon-wrapper h1, #coming-soon-wrapper h2, #coming-soon-wrapper h3, #coming-soon-wrapper h4, #coming-soon-wrapper h5, #coming-soon-wrapper h6, #coming-soon-wrapper p, #coming-soon-wrapper a, #coming-soon-wrapper button, #coming-soon-wrapper span, #coming-soon-wrapper div {
  font-family: "Sora", sans-serif !important;
}
#coming-soon-wrapper main {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

body.launch-locked {
  overflow: hidden !important;
}

/* El ejemplo reproduce el header y el hero oficiales del manual. */
.hero {
  flex-grow: 1;
  min-height: 620px;
}

/* Estado temporal de lanzamiento. Montar al final de body. */
.launch-veil {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
  padding: clamp(24px, 5vw, 72px);
  background: rgba(10, 20, 16, 0.3);
  backdrop-filter: blur(8px) saturate(0.92);
  -webkit-backdrop-filter: blur(8px) saturate(0.92);
  cursor: default;
}

.launch-message {
  position: relative;
  isolation: isolate;
  width: min(520px, 100%);
  min-height: 560px;
  height: auto;
  padding: 40px 44px 38px;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(255, 255, 255, 0.48);
  border-radius: 32px;
  background: rgba(247, 245, 241, 0.88);
  box-shadow: 0 28px 80px rgba(8, 20, 15, 0.22);
  backdrop-filter: blur(16px) saturate(1.04);
  -webkit-backdrop-filter: blur(16px) saturate(1.04);
  text-align: left;
  justify-self: center;
}
.launch-message a.btn-primary:hover {
  background-color: #719D82 !important;
  color: #ffffff !important;
  border-color: #719D82 !important;
}

.launch-message::before {
  content: "";
  position: absolute;
  z-index: -1;
  inset: auto -92px -126px auto;
  width: 310px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(130, 177, 148, 0.25), rgba(130, 177, 148, 0) 68%);
}

.launch-message__brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: max-content;
  margin: 30px 0 18px;
}

.launch-message__content {
  align-self: start;
  margin-top: 14px;
}

.launch-message__logo {
  width: 210px;
  height: auto;
}

.launch-message__flower {
  width: 210px;
  height: 210px;
  object-fit: contain;
  filter: drop-shadow(0 16px 28px rgba(34, 49, 42, 0.2));
}

.launch-message h2 {
  margin: 0;
  color: var(--bw-text-primary, #13231D);
  font-family: "Sora", sans-serif !important;
  font-size: 40px;
  line-height: 1.03;
  font-weight: 700;
  letter-spacing: -0.045em;
}

.launch-message__copy {
  max-width: 42ch;
  margin: 18px 0 0;
  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));
  font-family: "Sora", sans-serif !important;
  font-size: 16px;
  line-height: 1.65;
  font-weight: 400;
}

.launch-message__copy p {
  margin: 0;
}

.launch-message__copy p + p {
  margin-top: 10px;
}

.launch-message__status {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin-top: 26px;
  color: rgba(19, 35, 29, 0.62);
  font-family: "Sora", sans-serif !important;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 700;
}

.launch-message__status::before {
  content: "";
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--primary, #82B194);
  box-shadow: 0 0 0 5px rgba(130, 177, 148, 0.15);
}

@media (max-width: 900px) {
  .header .nav,
  .header .actions {
    display: none;
  }
  .header-inner {
    display: flex;
    justify-content: center;
    padding-inline: 20px;
  }
  .launch-veil {
    grid-template-columns: 1fr;
    align-items: end;
    padding: 18px;
  }
  .launch-message {
    height: min(640px, 100dvh - 36px);
    min-height: 0;
    padding: 30px 26px;
    border-radius: 24px;
  }
  .launch-message__brand {
    gap: 10px;
    margin: 22px 0 26px;
  }
  .launch-message__logo {
    width: 160px;
  }
  .launch-message__flower {
    width: 160px;
    height: 160px;
  }
  .launch-message h2 {
    font-size: 34px;
  }
  .hero-content {
    right: 24px;
    width: calc(100% - 48px);
  }
}
@media (max-height: 760px) {
  .launch-veil {
    padding: 16px clamp(24px, 5vw, 72px);
  }
  .launch-message {
    height: calc(100dvh - 32px);
    min-height: 0;
    padding-top: 26px;
    padding-bottom: 24px;
  }
  .launch-message__brand {
    margin: 28px 0 14px;
  }
  .launch-message__logo {
    width: 178px;
  }
  .launch-message__flower {
    width: 178px;
    height: 178px;
  }
  .launch-message__copy {
    margin-top: 12px;
    line-height: 1.5;
  }
  .launch-message__status {
    margin-top: 14px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .hero-video {
    display: none;
  }
  .hero {
    background: #13231D;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ComingSoon/ComingSoonStyles.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,0CAAA;AAAF;AAEE;EACE,0CAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AADJ;;AAKA;EACE,2BAAA;AAFF;;AAKA,mEAAA;AACA;EACE,YAAA;EACA,iBAAA;AAFF;;AAKA,6DAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,oDAAA;EACA,mBAAA;EACA,+BAAA;EACA,iCAAA;EACA,yCAAA;EACA,iDAAA;EACA,eAAA;AAFF;;AAKA;EACE,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,2CAAA;EACA,mBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,kDAAA;EACA,gBAAA;EACA,oBAAA;AAFF;AAIE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AAFJ;;AAMA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,0FAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,YAAA;EACA,YAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sDAAA;AAHF;;AAMA;EACE,SAAA;EACA,sCAAA;EACA,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,uDAAA;EACA,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,SAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mCAAA;EACA,+CAAA;AAHF;;AAMA;EACE;;IAEE,aAAA;EAHF;EAKA;IACE,aAAA;IACA,uBAAA;IACA,oBAAA;EAHF;EAKA;IACE,0BAAA;IACA,gBAAA;IACA,aAAA;EAHF;EAKA;IACE,iCAAA;IACA,aAAA;IACA,kBAAA;IACA,mBAAA;EAHF;EAKA;IACE,SAAA;IACA,mBAAA;EAHF;EAKA;IACE,YAAA;EAHF;EAKA;IACE,YAAA;IACA,aAAA;EAHF;EAKA;IACE,eAAA;EAHF;EAKA;IACE,WAAA;IACA,wBAAA;EAHF;AACF;AAMA;EACE;IACE,oCAAA;EAJF;EAMA;IACE,2BAAA;IACA,aAAA;IACA,iBAAA;IACA,oBAAA;EAJF;EAMA;IACE,mBAAA;EAJF;EAMA;IACE,YAAA;EAJF;EAMA;IACE,YAAA;IACA,aAAA;EAJF;EAMA;IACE,gBAAA;IACA,gBAAA;EAJF;EAMA;IACE,gBAAA;EAJF;AACF;AAOA;EACE;IACE,aAAA;EALF;EAOA;IACE,mBAAA;EALF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&display=swap');\n\n#coming-soon-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n  font-family: 'Sora', sans-serif !important;\n\n  h1, h2, h3, h4, h5, h6, p, a, button, span, div {\n    font-family: 'Sora', sans-serif !important;\n  }\n\n  main {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n  }\n}\n\nbody.launch-locked {\n  overflow: hidden !important;\n}\n\n/* El ejemplo reproduce el header y el hero oficiales del manual. */\n.hero {\n  flex-grow: 1;\n  min-height: 620px;\n}\n\n/* Estado temporal de lanzamiento. Montar al final de body. */\n.launch-veil {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  align-items: center;\n  padding: clamp(24px, 5vw, 72px);\n  background: rgba(10, 20, 16, 0.30);\n  backdrop-filter: blur(8px) saturate(0.92);\n  -webkit-backdrop-filter: blur(8px) saturate(0.92);\n  cursor: default;\n}\n\n.launch-message {\n  position: relative;\n  isolation: isolate;\n  width: min(520px, 100%);\n  min-height: 560px;\n  height: auto;\n  padding: 40px 44px 38px;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(255, 255, 255, 0.48);\n  border-radius: 32px;\n  background: rgba(247, 245, 241, 0.88);\n  box-shadow: 0 28px 80px rgba(8, 20, 15, 0.22);\n  backdrop-filter: blur(16px) saturate(1.04);\n  -webkit-backdrop-filter: blur(16px) saturate(1.04);\n  text-align: left;\n  justify-self: center;\n\n  a.btn-primary:hover {\n    background-color: #719D82 !important;\n    color: #ffffff !important;\n    border-color: #719D82 !important;\n  }\n}\n\n.launch-message::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  inset: auto -92px -126px auto;\n  width: 310px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(130, 177, 148, 0.25), rgba(130, 177, 148, 0) 68%);\n}\n\n.launch-message__brand {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: max-content;\n  margin: 30px 0 18px;\n}\n\n.launch-message__content {\n  align-self: start;\n  margin-top: 14px;\n}\n\n.launch-message__logo {\n  width: 210px;\n  height: auto;\n}\n\n.launch-message__flower {\n  width: 210px;\n  height: 210px;\n  object-fit: contain;\n  filter: drop-shadow(0 16px 28px rgba(34, 49, 42, 0.20));\n}\n\n.launch-message h2 {\n  margin: 0;\n  color: var(--bw-text-primary, #13231D);\n  font-family: 'Sora', sans-serif !important;\n  font-size: 40px;\n  line-height: 1.03;\n  font-weight: 700;\n  letter-spacing: -0.045em;\n}\n\n.launch-message__copy {\n  max-width: 42ch;\n  margin: 18px 0 0;\n  color: var(--bw-text-secondary, rgba(19, 35, 29, 0.68));\n  font-family: 'Sora', sans-serif !important;\n  font-size: 16px;\n  line-height: 1.65;\n  font-weight: 400;\n}\n\n.launch-message__copy p {\n  margin: 0;\n}\n\n.launch-message__copy p + p {\n  margin-top: 10px;\n}\n\n.launch-message__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  margin-top: 26px;\n  color: rgba(19, 35, 29, 0.62);\n  font-family: 'Sora', sans-serif !important;\n  font-size: 12px;\n  line-height: 1.4;\n  font-weight: 700;\n}\n\n.launch-message__status::before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  flex: 0 0 auto;\n  border-radius: 50%;\n  background: var(--primary, #82B194);\n  box-shadow: 0 0 0 5px rgba(130, 177, 148, 0.15);\n}\n\n@media (max-width: 900px) {\n  .header .nav,\n  .header .actions {\n    display: none;\n  }\n  .header-inner {\n    display: flex;\n    justify-content: center;\n    padding-inline: 20px;\n  }\n  .launch-veil {\n    grid-template-columns: 1fr;\n    align-items: end;\n    padding: 18px;\n  }\n  .launch-message {\n    height: min(640px, calc(100dvh - 36px));\n    min-height: 0;\n    padding: 30px 26px;\n    border-radius: 24px;\n  }\n  .launch-message__brand {\n    gap: 10px;\n    margin: 22px 0 26px;\n  }\n  .launch-message__logo {\n    width: 160px;\n  }\n  .launch-message__flower {\n    width: 160px;\n    height: 160px;\n  }\n  .launch-message h2 {\n    font-size: 34px;\n  }\n  .hero-content {\n    right: 24px;\n    width: calc(100% - 48px);\n  }\n}\n\n@media (max-height: 760px) {\n  .launch-veil {\n    padding: 16px clamp(24px, 5vw, 72px);\n  }\n  .launch-message {\n    height: calc(100dvh - 32px);\n    min-height: 0;\n    padding-top: 26px;\n    padding-bottom: 24px;\n  }\n  .launch-message__brand {\n    margin: 28px 0 14px;\n  }\n  .launch-message__logo {\n    width: 178px;\n  }\n  .launch-message__flower {\n    width: 178px;\n    height: 178px;\n  }\n  .launch-message__copy {\n    margin-top: 12px;\n    line-height: 1.5;\n  }\n  .launch-message__status {\n    margin-top: 14px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .hero-video {\n    display: none;\n  }\n  .hero {\n    background: #13231D;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
